import styled from 'styled-components';
import React from 'react';
import { token } from '@zillow/constellation';

const LinearProgressContainer = styled.div`
  position: relative;
  height: 3px;
`;

const BackgroundLine = styled.div`
  position: absolute;
  top: 1px;
  left: 0px;
  width: 100%;
  border: 1px solid ${token('colors.borderLight')};
`;

const ProgressLine = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  border: 2px solid ${token('colors.blue400')};
  transition: width 0.5s ease-in-out;
`;

export interface Props {
  progress: number;
  className?: string;
}

function LinearProgress({ progress, className }: Props) {
  return (
    <LinearProgressContainer className={className}>
      <BackgroundLine />
      {progress > 0 && <ProgressLine style={{ width: `${progress}%` }} />}
    </LinearProgressContainer>
  );
}

export default LinearProgress;
